import React, { useState } from 'react';

import Modal from 'react-modal';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import {
    cleanStandardData
} from '../../utils/cleanRawData'
import constructName from '../../utils/constructName'

import '../../styles/profile.css'
import ProfileCentroCopy from '../../shared/containers/InvestigadorProfileCentrosModal';
import { Grid } from '@material-ui/core';
import { Logo } from '../../shared/components/Logo';
import { NoDataTabsMessage } from '../../shared/components/NoDataTabsMessage';
import { universidades_engineData } from "../../data";

Modal.setAppElement('#root');

const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '50%',
      transform             : 'translate(-50%, -50%)'
    }
}
export default function Profile (props) {
    const [showModal, setShowModal] = useState(false)
    const [showCentroModal, setShowCentroModal] = useState(false)
    
    //datos para mostrar
    const { 
        rut, 
        universidad, 
        centro,
        profesion,
        nombre_titulo_grado,
        pi
    } = props.data;
    
    const isDataEmpy = ( data )=>{
        if( !!data && data !=='null' ){
            return false
        }else{
            return true
        }
    }

    const handleOpenModal= ()=> {
        setShowModal(true)
    }

    function handleOpenCentroModal(){
        if( props.data.id_centro.raw.trim().length  > 0 ){
            setShowCentroModal(true)
        }
    }
      
    function handleCloseModal () {
        setShowModal(false)
    }

    function handleCloseCentroModal(){
        setShowCentroModal(false)
    }

    return (
        <div>
            <div onClick={ handleOpenModal }
                className="btn-ver-mas" 
            >Ver más
            </div>
            <Modal 
                isOpen={ showModal }
                contentLabel="Modal"
                style={customStyles}
                onRequestClose={ handleCloseModal }
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
            >   
                <div className="modal-header">
                    <button 
                        onClick={ handleCloseModal }
                        className="btn-header"
                    >
                        volver
                    </button>
                    <div className="modal-header-logo">
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid
                                container
                                item
                                xs={7}
                            >
                                <Logo />

                            </Grid>
                        </Grid>
                    </div>
                </div>


                <div className="modal-title">
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid 
                            container 
                            item
                            xs={2}
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                        >
                                <img 
                                    src={ `/avatar/${rut?.snippet}.jpg` }
                                    onError={ (e)=> {e.target.onerror = null; e.target.src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fzancada.com%2Fwp-content%2Fimagenes%2F2012%2F12%2Ffacebook-profile-picture-n-copy.jpg&f=1&nofb=1"} } 
                                    alt="Foto de perfil del investigador" 
                                    className="modal-avatar"
                                />
                        </Grid>
                        <Grid item xs>
                            <ul className="modal-userData">
                                <li className="modal-userData__name">
                                    { constructName(props.data).replaceAll("<em>","").replaceAll("</em>","") }  
                                </li>

                                <li className="modal-userData__info">
                                    { universidad?.raw }
                                </li>

                                <li className="modal-userData__info">
                                {
                                    centro.raw === null || centro.raw === "N/A" || centro.snippet === "N"
                                    ? ""
                                    : <span dangerouslySetInnerHTML={{__html: centro?.raw}}></span>
                                }
                                </li>
                            </ul>
                        </Grid>
                    </Grid>
                </div>

                <div className="modal-body">

                    <div className="modal-profile">
                        <div className="modal-profile-header">
                        
                        </div>
                    </div>
                    <div className="modal-tabs">
                        <Tabs >
                            <TabList>
                                <Tab>
                                    <b className="tab-title">Overview</b>
                                </Tab>
                                <Tab>
                                    <b className="tab-title">Investigación</b>
                                </Tab>
                                <Tab >
                                    <b className="tab-title">Publicaciones</b>
                                </Tab>
                                <Tab>
                                    <b className="tab-title">Proyectos</b>
                                </Tab>
                                <Tab className="react-tabs__tab Tab-PI">
                                    <b className="tab-title">Prop. Intelectual</b>
                                </Tab>
                                {
                                    ( centro.raw !== '' || ! (!!centro.raw) || centro.raw !== "N/A" || centro.raw !== 'N' ) && (
                                        <Tab>
                                            <b className="tab-title">Centro</b>
                                        </Tab>
                                    )
                                }
                            </TabList>

                            {/* Overview */}
                            <TabPanel> 
                                <div>
                                    <h4>Estudios</h4>
                                    <ul>
                                        {
                                            profesion?.raw && (
                                                profesion.raw.split('|').map( (individualProfesion,index)=>
                                                    {
                                                        return <li key={index}>{individualProfesion}</li>
                                                    } 
                                                )
                                            )
                                        }

                                        {
                                            !isDataEmpy( nombre_titulo_grado?.raw ) && (
                                                nombre_titulo_grado.raw.split(',').map( (individualTitleGradeName,index)=>
                                                    {
                                                        return <li key={index}>{individualTitleGradeName.toLowerCase()}</li>
                                                    } 
                                                )
                                            )
                                        }
                                    </ul>
                                    
                                </div>    

                                {
                                    !isDataEmpy( props.data.resumen?.snippet ) && 
                                    <div>
                                        <h4>Resumen</h4>
                                        <span className="capitalize-first" dangerouslySetInnerHTML={{__html: props.data.resumen?.raw}}></span>
                                    </div>
                                }
                                {
                                    !isDataEmpy( props.data.descripcion?.snippet ) && 
                                    <div>
                                        <h4>Descripci&oacute;n</h4>
                                        <span dangerouslySetInnerHTML={{__html: props.data.descripcion?.raw}}></span>
                                    </div>
                                }

                                { props.data.directorios_empresariales_en_los_ultimos_24_meses.snippet === 'No' || props.data.directorios_empresariales_en_los_ultimos_24_meses.snippet === null
                                    ? <div></div>
                                    : <div><h4>Directorios empresariales últimos 24 meses</h4><span dangerouslySetInnerHTML={{__html: cleanStandardData(props.data.directorios)}}></span></div>
                                }

                                { props.data.ha_participado_en_mesas_sectoriales_en_los_ultimos.snippet === 'No' || props.data.ha_participado_en_mesas_sectoriales_en_los_ultimos.snippet === null
                                    ? <div></div>
                                    : <div><h4>Mesas sectoriales</h4><span dangerouslySetInnerHTML={{__html: cleanStandardData(props.data.mesas_sectoriales)}}></span></div>
                                }
                                <div>
                                    <h4>Datos de contacto</h4>
                                    {
                                        props.data.incorporar_link_portal_del_investigador_anid.snippet === null || props.data.incorporar_link_portal_del_investigador_anid.snippet === ""
                                        ? ""
                                        : <span>
                                            { <a className="link" href={props.data.incorporar_link_portal_del_investigador_anid.raw} rel="noopener noreferrer" target="_blank">Perfil ANID</a> }
                                            </span>
                                    }
                                    {
                                        props.data.link_portal_scopus.snippet === null || props.data.link_portal_scopus.snippet === ""
                                        ? ""
                                        : <span>{ <br/>}{<a className="link" href={props.data.link_portal_scopus.raw} rel="noopener noreferrer" target="_blank">Perfil SCOPUS </a> }</span>
                                    }
                                    {
                                        props.data.link_linked.snippet === null || props.data.link_linked.snippet === ""
                                        ? ""
                                        : <span>{<br/>}{<a className="link" href={props.data.link_linked.snippet} rel="noopener noreferrer" target="_blank">Perfil Linkedin </a>}</span>
                                    }

                                    {
                                        
                                        props.data.id_orcid?.snippet
                                        && (
                                            <div>
                                                <a className="link" rel="noopener noreferrer" target="_blank" href={ `${props.data.id_orcid.snippet}` }>Código orcid</a>
                                            </div>
                                        )

                                        
                                    }

                                    {!(props.data.incorporar_link_portal_del_investigador_anid.snippet === null || props.data.incorporar_link_portal_del_investigador_anid.snippet === "") ||
                                        !(props.data.link_portal_scopus.snippet === null || props.data.link_portal_scopus.snippet === "") ||
                                        !(props.data.link_linked.snippet === null || props.data.link_linked.snippet === "")
                                        ? <span><br/><br/></span>:""}
                                    
                                    <div className='email'>
                                            Correo electronico: <a className="link" href={ `mailto:${props.data.email?.raw}` }>{ props.data.email.raw } </a>
                                    </div>
                                    { universidades_engineData.filter( u => u.id.toUpperCase() === universidad.raw.toUpperCase())[0]?.contacto }
                                    

                                </div>
                            </TabPanel>

                            {/* Investigacion */}
                            <TabPanel>
                                <div>
                                    {
                                        props.data.investigacion.raw.map( (element, index) => {
                                            let investigacion = JSON.parse(element)
                                            return (
                                                <div key={index}>
                                                    <h4 style={{paddingLeft: '20px'}}>{investigacion['nombre_de_la_linea_de_investigacion']}</h4>
                                                    <div>
                                                        <p style={{paddingLeft: '20px'}}>{investigacion['desarrollo_soluciones_que_permitan_abordar_los_desafios_o_problematicas']}</p>
                                                    </div>
                                                    <ul>
                                                        {<li> <b>Industrias:</b> {investigacion['industrias']?.split(';').map((element,index) => {
                                                            let industria = element;
                                                            return <div style={{backgroundColor:'white', margin:'3px' ,border: '1px solid lightgrey', borderRadius:'3px', padding:'2px', display:'inline-block'}} key={index}>{industria}</div>
                                                            
                                                        })}</li>}
                                                        
                                                    </ul>
                                                </div>
                                            )
                                        })
                                    }                                                                    
                                </div>
                            </TabPanel>

                            {/* Publicaciones */}
                            <TabPanel>
                                <div>
                                    {
                                        props.data.investigadores_anid.snippet===null?
                                        <div></div>:
                                        <h4>Publicaciones científicas</h4>
                                    }

                                    {
										props.data.investigadores_anid.raw.length > 0 ? props.data.investigadores_anid.raw.map( (element, index) => {
                                            let publicacion = JSON.parse(element)
                                            const showPublicacion = publicacion["tipo_publicacion"].toLowerCase().includes("proyecto") ? false : true;
                                            return (
                                                showPublicacion &&
                                                (
                                                    <div key={index}>
                                                        <div><a className="link link--800" href={publicacion["link_publicacion"]} rel="noopener noreferrer" target="_blank">{  publicacion["titulo_publicacion"]}</a></div>
                                                        {
                                                            publicacion["colaboradores"]==="null"?
                                                            <></>
                                                            :<div>
                                                                    {/* year */}
                                                                    <div>
                                                                        { publicacion["publicado_en"] && `${publicacion["publicado_en"]}` }
                                                                        { ( publicacion["lugar_anio_publicacion"] && publicacion["publicado_en"]) && ', ' }
                                                                        { publicacion["lugar_anio_publicacion"]  && `${ publicacion["lugar_anio_publicacion"] } ` }
                                                                    </div>
                                                                    <div>
                                                                    { !isDataEmpy( publicacion["colaboradores"]?.replace(';','') ) && publicacion["colaboradores"]?.replace(';', ',')  }
                                                                    </div>

                                                                    <div>
                                                                    { !isDataEmpy( publicacion["resumen"] )   &&  `${publicacion["resumen"] }`} { publicacion["resumen"]?.length === 150 && '...'}
                                                                    </div>
                                                             </div>
                                                        }

                                                        <br></br>
                                                    </div>
                                                )
                                            )
                                        })
										: universidad.raw === 'UDD' ? <NoDataTabsMessage  message={'Este investigador está en proceso de actualización de su información.'}/> : null
                                    }
                                    
                                </div>

                            </TabPanel>
                            {/* Proyectos */}
                            <TabPanel>
                                    {
										( props.data.proyectos?.raw.length > 0 ) ? props.data.proyectos?.raw.map( ( proyectoJSON, index ) =>
											{
												const proyecto = JSON.parse(proyectoJSON);
												return (
													<>
														<div key={ index }>
															<h4>
																{ proyecto.proyecto }
															</h4>

															{
																( proyecto.fuente_financiacion === null || proyecto.fuente_financiacion  === "" ) 
																? <></>
																: (
																<div>
																	<span>Fuente Financiamiento: { proyecto.fuente_financiacion }</span>
																</div>
																)
															}

															{
																( proyecto.anio_publicacion === null || proyecto.anio_publicacion  === "" || !proyecto.anio_publicacion ) 
																? <></>
																: (
																<div>
																	<span>Año de adjudicación: { proyecto.anio_publicacion }</span>
																</div>
																)
															}
														</div>
													</>

												)
											}) 
											: universidad.raw === 'UDD' ? <NoDataTabsMessage  message={'Este investigador está en proceso de actualización de su información.'}/> : null
											
                                    }
                            </TabPanel>

                            {/*** Propiedad Intelectual */}
                            <TabPanel>
								
								{
									
									(pi?.raw.length > 0 ) ? pi.raw.map( (element, index) => {
										//console.log('entró para', props.data.nombres?.snippet);
										/*                                                 anio_solicitud: 2015
										nro_solicitud: "201502971"
										observaciones: ""
										solicitante_adicional: "Marcelo Ezquer"
										titulo */
										let pi = JSON.parse(element);
										return (
											<div key={index}>
												<p style={ { margin:'0' } } className="link link--800"> { pi.titulo } </p>
												<div>
													<span>
													    Año: { pi.anio_solicitud }
													</span>
												</div>
												
												<div>
													<span>
													    Número de Solicitud: { pi.nro_solicitud }
													</span>
												</div>
												
												<div>
													<span>
													    { pi.observaciones }
													</span>
												</div>
												
												<div>
													<span>
													    Autor(es): { pi.solicitante_adicional }
													</span>
												</div>
												<br></br>
											</div>
										)
									}) // in this second validation we put the NoData message only if the university is UDD, otherwise we let the screen on blank
									: universidad.raw === 'UDD' ? <NoDataTabsMessage message={'Este investigador aun no ha participado de procesos de Protección Intelectual.'}/> : null
								}


                            </TabPanel>
                            {/* Centros */}
                            <TabPanel>
                                <div>
                                    {centro.raw === null || centro.raw === "N/A" || ! (!!centro.raw) || centro.raw === 'N' ?
                                        null
                                        :
                                        (
                                            <>
                                                <span
                                                    dangerouslySetInnerHTML={{__html: centro.raw || ''}}>
                                                </span>
                                                <span
                                                    onClick={ ()=> handleOpenCentroModal()  }
                                                    style={ { marginLeft: '10px', backgroundColor: 'var( --primary )', padding: '3.5px 10px', cursor: 'pointer', borderRadius: '30px', textAlign: 'center', color: 'white' } }>
                                                    Ver m&aacute;s
                                                </span>
                                            </>

                                        )
                                    }
                                </div>
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
                <Modal 
                    isOpen={ showCentroModal }
                    contentLabel="Modal"
                    style={customStyles}
                    onRequestClose={ handleCloseCentroModal }
                    shouldCloseOnOverlayClick={true}
                    shouldCloseOnEsc={true}
                >
                    <div className="modal-header">
                        <button 
                            onClick={ handleCloseCentroModal }
                            className="btn-header"
                        >
                            volver
                        </button>
                        <div className="modal-header-logo">
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid
                                    container
                                    item
                                    xs={7}
                                >
                                    <Logo />

                                </Grid>
                            </Grid>
                        </div>

                        
                    </div>
                    <ProfileCentroCopy id={ props.data.id_centro.raw }/>
                </Modal>
                {/* <div dangerouslySetInnerHTML={{__html: JSON.stringify(props.data)}}></div> */}
            </Modal>
        </div>
    )
}
